import { Component, Input, OnDestroy, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { Subscription } from 'rxjs/internal/Subscription';
import { ModalBase } from 'src/app/model/modal-base';
import { PlayerService } from 'src/app/services/player.service';
import { ModalComponent } from '../modal.component/modal.component';

@Component({
    selector: 'app-login-needed-modal',
    templateUrl: './login-needed-modal.component.html'
})
export class LoginNeededModalComponent extends ModalBase implements OnDestroy
{
    @ViewChild('modal', { static: true })
    public modal: ModalComponent;
    @Input('expired')
    public expired?: boolean;
    public isExpired = false;
    private playerAuthorizedRenewSubscription: Subscription;

    public constructor(
        private playerService: PlayerService,
        private router:Router){
        super();
    }

    public open(closeable:boolean): void
    {
        if (!this.isOpen())
        {
            super.open(closeable);
        }
    }

    public browserRefresh(): void
    {
        location.reload();
    }

    public gotoLogin():void {
        this.router.navigateByUrl('/login')
    }

    public async renew(): Promise<void>
    {
      // Even this should fail we just close the modal
      try {
        await firstValueFrom(this.playerService.authRefresh());
      } catch (error) {
        console.error('Auth refresh failed:', error);
      }
      
      this.expired = false;
      super.close();
    }

    public ngOnDestroy(): void
    {
        if (this.playerAuthorizedRenewSubscription)
        {
            this.playerAuthorizedRenewSubscription.unsubscribe();
        }
    }
}
